<template>
  <section class="container">
    <div class="main">
      <div class="header">
        <h2>新增证书</h2>
        <div class="btn">
          <v-button
            gray
            @click="handleCancel">返回</v-button>
          <v-button
            green
            @click="handleConfirm">确定</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div
          class="box">
          <div class="form form1">
            <div class="item">
              <span class="item-title">Effective Date<br>生效日期</span>
              <el-form-item
                :rules="rules.select"
                prop="pcy_cmnt_dt">
                <v-date-picker
                  v-model="formData.pcy_cmnt_dt"
                  :picker-options="pickerOptions"
                />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Client Type<br>客户类型</span>
              <el-form-item
                ref="cust_typ"
                :rules="rules.select"
                prop="cust_typ"
              >
                <v-radio-group
                  v-model="formData.cust_typ"
                  border
                  flex
                  :list="personTypeist"
                ></v-radio-group>
              </el-form-item>
            </div>
            <template v-if="formData.cust_typ!=2">
              <div class="flex-sb-center mg-t-15">
                <div class="form-item form-half">
                  <span class="item-title">Last Name<br>姓氏</span>
                  <el-form-item
                    ref="isrd_lst_nm"
                    prop="isrd_lst_nm">
                    <v-input
                      v-model="formData.isrd_lst_nm"
                      placeholder="Last Name"
                      uppercase
                    />
                  </el-form-item>
                </div>
                <div class="form-item form-half ">
                  <span class="item-title">First Name<br>名字</span>
                  <el-form-item
                    ref="isrd_fst_nm"
                    prop="isrd_fst_nm">
                    <v-input
                      v-model="formData.isrd_fst_nm"
                      placeholder="First Name"
                      uppercase
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="item">
                <el-form-item
                  ref="id_type"
                  prop="id_type"
                  :show-message="false"
                  :rules="rules.select"
                >
                  <v-radio-group
                    v-model="formData.id_type"
                    flex
                    is-slot
                    :list="personalIdTypOptions">
                    <template #default="{item}">
                      <span class="item-title">{{item.name}}<br>{{item.name_zh}}</span>
                    </template>
                  </v-radio-group>
                </el-form-item>
                <el-form-item
                  ref="id_no"
                  :rules="rules.id_no"
                  prop="id_no">
                  <v-input
                    v-model="formData.id_no"
                    placeholder="A123456(3), please input A1234563"
                    uppercase
                    key-non-chinese></v-input>
                </el-form-item>
              </div>
            </template>
            <template  v-else>
              <div
                class="item">
                <span class="item-title">Company Name<br>公司名称</span>
                <el-form-item
                  ref="isrd_com_nm"
                  prop="isrd_com_nm">
                  <v-input
                    v-model="formData.isrd_com_nm"
                    key-non-chinese
                    uppercase
                  ></v-input>
                </el-form-item>
              </div>
              <div
                class="item">
                <span class="item-title">BR Number<br>商业登记证号码</span>
                <el-form-item
                  ref="id_no"
                  :rules="rules.input"
                  prop="id_no">
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    key-non-chinese></v-input>
                </el-form-item>
              </div>
            </template>
            <div class="item">
              <span class="item-title">Mobile No. <br>电话号码</span>
              <el-form-item
                ref="mobile_no"
                :rules="rules.mobile_no"
                prop="mobile_no">
                <v-input
                  v-model="formData.mobile_no"
                  key-number
                  maxlength="8"
                  key-non-chinese></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Registration Mark<br>车牌号码</span>
              <el-form-item
                ref="rgtn_no"
                :rules="rules.input"
                prop="rgtn_no">
                <v-input
                  v-model="formData.rgtn_no"
                  key-non-chinese
                  uppercase
                  maxlength="8"
                ></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Make<br>车厂</span>
              <el-form-item
                ref="brand"
                :rules="rules.select"
                prop="brand">
                <v-radio-group
                  v-model="formData.brand"
                  flex
                  border
                  :list="brandList">
                </v-radio-group>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Model<br>型号</span>
              <el-form-item
                ref="rgtn_mdl"
                :rules="rules.input"
                prop="rgtn_mdl">
                <v-input
                  v-model="formData.rgtn_mdl"
                  key-non-chinese
                  uppercase
                ></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Year of Manufacture<br>出厂年份</span>
              <el-form-item
                ref="rgtn_yr"
                :rules="rules.input"
                prop="rgtn_yr">
                <v-input
                  v-model="formData.rgtn_yr"
                  key-non-chinese
                  key-number
                  maxlength="4"
                ></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Chassis Number<br>底盘号码</span>
              <el-form-item
                ref="chasis_no"
                :rules="rules.input"
                prop="chasis_no">
                <v-input
                  v-model="formData.chasis_no"
                  key-non-chinese
                  uppercase
                ></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Plan<br>保险计划</span>
              <el-form-item
                ref="plan_id"
                :rules="rules.select"
                prop="plan_id">
                <v-select
                  v-model="formData.plan_id"
                  :list="globalOptions.plans"
                ></v-select>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">SMS Language<br>短信语言</span>
              <el-form-item
                ref="send_language"
                :rules="rules.select"
                prop="send_language">
                <v-radio-group
                  v-model="formData.send_language"
                  :list="globalOptions.language"
                ></v-radio-group>
              </el-form-item>
            </div>
          </div>
        </div>

      </el-form>
      <div class="footer">
        <v-button
          gray
          @click="handleCancel">返回</v-button>
        <v-button
          green
          @click="handleConfirm">确定</v-button>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {saveOrder} from '@/api/order'
import IDCheck from '@/utils/idcheck'
import axios from 'axios'
import dayjs from 'dayjs'
export default {
  name: 'certificatesForm',
  components:{
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    from:{
      type:Object,
      default:()=>({})
    },
    isEdit:{
      type:Boolean,
      default:false
    },
  },
  data () {
    const checkIdNo = (rule, value, callback) => {
      const { id_no,id_type } = this.formData
      if(!id_no)
      {
        callback(new Error('Please enter 请输入'))
      }
      if(value&&!IDCheck(value)&&id_type==1) {
        callback(new Error('Please enter the correct id card'))
      }
      if(!id_no&&id_type==2)
      {
        callback(new Error('Please enter 请输入'))
      }
      callback()
    }
    return {
      formData:{
        mobile_no:'',
        rgtn_no: '',
        brand: '',
        rgtn_mdl:'',
        // contact_dt:'',
        rgtn_yr:'',
        // contact_time_id:'',
        chasis_no:'',
        plan_id: '',
        pcy_cmnt_dt: '',
        id_no:'',
        isrd_fst_nm:'',
        isrd_lst_nm:'',
        send_language:'',
        id_type:1,
        cust_typ:1
      },
      message:'',
      rules:{
        id_no: [
          { validator: checkIdNo, trigger: ['change', 'blur'] }
        ],
      }
    }
  },
  computed:{
    order_id(){
      let {id} = this.$route.query
      return id
    },
    pickerOptions(){
      return{
        disabledDate: (time) => {
          let today = dayjs()
          let end = dayjs(time)
          return end.diff(today, 'day') < 0
        },
      }
    },
  },
  watch:{
    from:{
      immediate:true,
      handler(val){
        if(this.isEdit){
          Object.keys(this.formData).some(key=>{
            this.formData[key] = val[key]
            // this.formData.brand = 'BYD'
          })
        }
      }
    }
  },
  mounted(){
  },
  methods: {

    handleCancel(){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        confirmBtn:'确定',
        title:'放弃编辑',
        isBtnRed:true,
        cancelBtn:'取消',
        message: '你确定要放弃此次编辑吗？'
      }).then(() => {
        if(!this.isEdit)
          return  this.$router.replace('/')
        this.$emit('cancel')
      })
    },
    handleConfirm(){
      this.$refs.form.validate( (valid) => {
        if (valid) {
          // 額外參數
          this.network().saveOrder()
        }
      })
    },
    network() {
      return {
        saveOrder: async (params={}) => {
          if(this.isEdit){
            params.order_id = this.order_id
          }
          let {cust_typ} = this.formData
          if(cust_typ == 2)
          {
            this.formData.id_type = 3
            delete this.formData.isrd_fst_nm
            delete this.formData.isrd_lst_nm
          }
          const { data } = await saveOrder({
            ...params,
            ...this.formData
          })
          this.$message({
            type: 'success',
            message: '保單已成功發出'
          })
          this.$emit('success')
          if(!this.isEdit)
            return  this.$router.replace('/')
        }
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.container{
  display: flex;
  padding: 0 70px;
  margin-top: 20px;
  min-height: calc(100vh - 150px);
  .main{
    margin-right: 30px;
    flex: 1;
    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      h2{
        padding: 0;
        font-weight: 600;
        font-size: 20px;
        color: #24292E;
      }
    }
    .box{
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 30px;
      .form{
        .item{
          .item-title{
            font-weight: 600;
            font-size: 14px;
            color: #24292E;
            margin-bottom: 8px;
            display: inline-block;
          }
          & + .item{
            margin-top: 20px;
          }
        }
      }
      .form1, .formData{
        width: 330px;
      }
      .tips{
        padding-left: 24px;
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #24292E;
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
    }
  }
  aside{
    width: 280px;
    .box-remark{
      .title{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
      }
      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
      }
    }
  }
  /deep/.birth{
    .year{
      width: 140px;
      margin-right: 0;
    }
  }
  ///deep/.el-radio-group{
  //  display: flex;
  //  flex-direction: column;
  //}
  ///deep/.el-radio{
  //  font-weight: 600;
  //  font-size: 14px;
  //  color: #24292E;
  //  & + .el-radio{
  //    margin-top: 4px;
  //  }
  //}
}
</style>
